import { ShieldCheck, FlaskConical, Headphones, Truck } from "lucide-react";

const features = [
  {
    icon: ShieldCheck,
    number: "01",
    title: "Quality Assurance",
    description: "Every batch undergoes rigorous lab testing. ISO 9001:2015 certified processes and BIS-compliant formulations ensure consistent quality across all the batches produced in our 365,000 tonnes annually production capacity."
  },
  {
    icon: FlaskConical,
    number: "02",
    title: "Scientific Formulation",
    description: "Developed by a team of experienced nutritionists and veterinary scientists using research-backed formulations optimized for Indian climatic conditions and regional raw materials."
  },
  {
    icon: Headphones,
    number: "03",
    title: "Farmer Support",
    description: "Dedicated on-farm consultation services with a team of field representatives across North India. Free farm visits, flock health assessments, and customized feeding schedules for optimal performance."
  },
  {
    icon: Truck,
    number: "04",
    title: "Timely Delivery",
    description: "Reliable doorstep delivery across Haryana, Punjab, UP, Rajasthan, and 20+ states through our trusted logistics partners, ensuring your feed arrives on time."
  },
];

const WhyChooseUs = () => {
  return (
    <section className="py-32 bg-primary text-primary-foreground relative overflow-hidden">
      {/* Decorative */}
      <div className="absolute right-0 top-0 w-1/3 h-full bg-gradient-to-l from-primary-glow/30 to-transparent pointer-events-none" />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16">
          {/* Left header */}
          <div className="lg:col-span-4">
            <span className="text-accent font-body text-xs uppercase tracking-[0.25em] font-semibold">Why Us</span>
            <h2 className="text-5xl md:text-6xl font-bold font-display mt-3 leading-[1.05]">
              Built on
              <br />
              <span className="italic font-normal text-accent">trust</span>
            </h2>
            <p className="text-primary-foreground/60 font-body mt-6 leading-relaxed">
              Founded in 1984 by Mukhtiar Singh Sandhu, today led by the Sandhu Brothers with four decades of commitment to poultry excellence. 98% customer retention rate — because results speak louder than promises.
            </p>
          </div>

          {/* Right — features as numbered blocks */}
          <div className="lg:col-span-7 lg:col-start-6 space-y-12">
            {features.map((feature) => {
              const Icon = feature.icon;
              return (
                <div key={feature.number} className="flex gap-8 group">
                  <span className="text-5xl font-display font-bold text-primary-foreground/20 transition-colors leading-none">
                    {feature.number}
                  </span>
                  <div className="border-t border-primary-foreground/10 pt-6 flex-1">
                    <div className="flex items-center gap-3 mb-3">
                      <Icon className="h-5 w-5 text-accent" />
                      <h3 className="text-xl font-bold font-display">{feature.title}</h3>
                    </div>
                    <p className="text-primary-foreground/60 font-body leading-relaxed max-w-md">{feature.description}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
